export default __webpack_public_path__ + "static/media/fxf-closed-logo.26ead50e.svg";